import Cookies from "js-cookie";

// The co-owner invitation credential belongs to the case, never to the login
// session. Keep legacy ?token= invitations readable alongside the new parameter.
export const isPropertyCoOwnerInvitationPath = (pathname) =>
  pathname.toLowerCase().replace(/\/+$/, "") === "/property-co-owner-myinfo";

export function consumeUrlLoginToken({
  location = window.location,
  replace = (url) => window.history.replaceState({}, document.title, url),
} = {}) {
  if (isPropertyCoOwnerInvitationPath(location.pathname)) return false;
  const params = new URLSearchParams(location.search);
  const token = params.get("token");
  if (!token) return false;
  Cookies.set("token", token, { expires: 7 });
  params.delete("token");
  const query = params.toString();
  replace(
    `${location.pathname}${query ? `?${query}` : ""}${location.hash || ""}`,
  );
  return true;
}
